import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 300000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  return config
}, error => {
  // Do something with request error
  //console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if(response&&response.headers&&response.headers.authorization){
      Cookies.set(TokenKey, response.headers.authorization)
    }
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
  // //console.log(response)

  if(response.data.type=="application/json"){
    return response.data
  }
    const res = response.data
    if (res.code !== 200) {
      if(res.code === 201){
        return response.data
      }
      
      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log('request.js=> 401未登录响应进入MessageBox回调')
          store.dispatch('FedLogOut').then(() => {
            console.log('进入前端登出store')
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }else if(res.code === 701){
        return 
      }else{
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
      return Promise.reject('error')
    } else {
     
      return response.data
    }
  },
  error => {
    //console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
  
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js